export const ColorTheme = {
    LIGHT: 'light',
    DARK: 'dark',
    YELLOW: 'yellow',
    BLUE: 'blue',
    ORANGE: "orange",
    GREEN: "green"
}